/*
 * Mailcheck https://github.com/mailcheck/mailcheck
 * Author
 * Derrick Ko (@derrickko)
 *
 * Released under the MIT License.
 *
 * v 1.1.0
 */

var Mailcheck = {
    domainThreshold: 2,
    secondLevelThreshold: 2,
    topLevelThreshold: 2,

    defaultDomains: ["gmail.com", "hotmail.com", "yahoo.com", "gmx.de", "web.de", "me.com", "aol.com", "hotmail.co.uk", "googlemail.com", "hotmail.fr",
        "live.com", "mail.ru", "yahoo.co.jp", "outlook.com", "icloud.com", "mac.com", "t-online.de", "hotmail.it", "msn.com", "yahoo.co.uk", "gmx.net",
        "yahoo.de", "hotmail.de", "comcast.net", "yahoo.fr", "libero.it", "naver.com", "yandex.ru", "live.co.uk", "free.fr", "ymail.com", "orange.fr",
        "btinternet.com", "hotmail.es", "live.fr", "freenet.de", "gmx.at", "yahoo.it", "bluewin.ch", "sbcglobal.net", "live.de", "gmx.ch", "wp.pl", "arcor.de",
        "alice.it", "hotmail.co.jp", "wanadoo.fr", "live.it", "live.nl", "yahoo.es", "seznam.cz", "verizon.net", "rocketmail.com", "laposte.net", "att.net",
        "telenet.be", "online.de", "qq.com", "o2.pl", "yahoo.com.br", "abv.bg", "sky.com", "yahoo.gr", "cox.net", "mail.com", "live.ca", "yahoo.ca",
        "berklee.edu", "tiscali.it", "sfr.fr", "ntlworld.com", "bk.ru", "earthlink.net", "rambler.ru", "i.softbank.jp", "yahoo.com.au", "live.com.au",
        "bigpond.com", "aim.com", "gmx.com", "nifty.com", "virgilio.it", "rogers.com", "hotmail.ca", "hanmail.net", "outlook.fr", "videotron.ca", "fullsail.edu",
        "blueyonder.co.uk", "outlook.de", "inbox.ru", "shaw.ca", "windowslive.com", "optonline.net", "bellsouth.net", "live.jp", "aon.at", "live.se", "outlook.es",
        "skynet.be", "list.ru", "yahoo.co.id", "freemail.hu", "interia.pl", "walla.com", "native-instruments.de", "trbvm.com", "nate.com", "ybb.ne.jp", "sympatico.ca",
        "charter.net", "telia.com", "talktalk.net", "yahoo.com.ar", "ezweb.ne.jp", "optusnet.com.au", "neuf.fr", "ziggo.nl", "online.no", "tin.it", "hotmail.ch", "live.dk",
        "ya.ru", "inbox.lv", "live.be", "ukr.net", "hotmail.nl", "op.pl", "live.com.mx", "home.nl", "email.cz", "chello.at", "yahoo.com.mx", "kabelmail.de", "iinet.net.au",
        "xs4all.nl", "hispeed.ch", "fastwebnet.it", "virginmedia.com", "tiscali.co.uk", "163.com", "yahoo.com.tw", "bol.com.br", "hotmail.be", "voila.fr", "azet.sk",
        "centrum.cz", "outlook.it", "hotmail.se", "outlook.jp", "live.com.ar", "hotmail.gr", "email.it", "docomo.ne.jp", "sapo.pt", "email.com", "live.com.pt",
        "ig.com.br", "live.no", "jcom.home.ne.jp", "telus.net", "btopenworld.com", "hotmail.com.ar", "softbank.ne.jp", "posteo.de", "upcmail.nl", "unitybox.de",
        "uol.com.br", "roadrunner.com", "sunrise.ch", "netcologne.de", "bbox.fr", "tlen.pl", "chello.nl", "planet.nl", "aol.de", "juno.com", "virgin.net", "telefonica.net",
        "terra.com.br", "mailinator.com", "yahoo.co.in", "kpnmail.nl", "mail.de", "yahoo.se", "bigpond.net.au", "club-internet.fr", "numericable.fr", "daum.net",
        "email.de", "y7mail.com", "citromail.hu", "onlinehome.de", "pacbell.net", "mindspring.com", "tpg.com.au", "inbox.com", "yahoo.no", "talk21.com", "gmx.fr",
        "aol.co.uk", "netscape.net", "yahoo.com.hk", "vp.pl", "bell.net", "eircom.net", "walla.co.il", "yopmail.com", "pandora.be", "inwind.it", "hotmail.no",
        "hotmail.co.nz", "luukku.com", "frontier.com", "126.com", "yahoo.ie", "poczta.fm", "xtra.co.nz", "nyu.edu", "ono.com", "yahoo.dk", "centrum.sk", "hotmail.com.au",
        "sharklasers.com", "live.cl", "internode.on.net", "aliceadsl.fr", "otenet.gr", "onet.pl", "yahoo.com.ph", "yandex.com", "lafilm.edu", "kolumbus.fi", "comhem.se",
        "live.at", "poczta.onet.pl", "live.ie", "netzero.net", "yahoo.ro", "mail.bg", "yahoo.in", "bredband.net", "yahoo.com.sg", "fastmail.fm", "vodafone.de", "btconnect.com",
        "quicknet.nl", "casema.nl", "noos.fr"],

    defaultSecondLevelDomains: ["yahoo", "hotmail", "mail", "live", "outlook", "gmx"],

    defaultTopLevelDomains: ["com", "com.au", "com.tw", "ca", "co.nz", "co.uk", "de", "fr", "it", "ru", "net", "org", "edu", "gov", "jp", "nl", "kr", "se", "eu",
        "ie", "co.il", "us", "at", "be", "dk", "hk", "es", "gr", "ch", "no", "cz", "in", "net", "net.au", "info", "biz", "mil", "co.jp", "sg", "hu", "com.br",
        "com.hk", "com.tr", "pl", "ne.jp"],

    run: function (opts) {
        opts.domains = opts.domains || Mailcheck.defaultDomains;
        opts.secondLevelDomains = opts.secondLevelDomains || Mailcheck.defaultSecondLevelDomains;
        opts.topLevelDomains = opts.topLevelDomains || Mailcheck.defaultTopLevelDomains;
        opts.distanceFunction = opts.distanceFunction || Mailcheck.sift3Distance;

        var defaultCallback = function (result) {
            return result
        };
        var suggestedCallback = opts.suggested || defaultCallback;
        var emptyCallback = opts.empty || defaultCallback;

        var result = Mailcheck.suggest(Mailcheck.encodeEmail(opts.email), opts.domains, opts.secondLevelDomains, opts.topLevelDomains, opts.distanceFunction);

        return result ? suggestedCallback(result) : emptyCallback()
    },

    suggest: function (email, domains, secondLevelDomains, topLevelDomains, distanceFunction) {
        email = email.toLowerCase();

        var emailParts = this.splitEmail(email);

        var closestDomain = this.findClosestDomain(emailParts.domain, domains, distanceFunction, this.domainThreshold);

        if (closestDomain) {
            if (closestDomain == emailParts.domain) {
                // The email address exactly matches one of the supplied domains; do not return a suggestion.
                return false
            } else {
                // The email address closely matches one of the supplied domains; return a suggestion
                return {address: emailParts.address, domain: closestDomain, full: emailParts.address + "@" + closestDomain};
            }
        }

        // The email address does not closely match one of the supplied domains
        var closestSecondLevelDomain = this.findClosestDomain(emailParts.secondLevelDomain, secondLevelDomains, distanceFunction, this.secondLevelThreshold);
        var closestTopLevelDomain = this.findClosestDomain(emailParts.topLevelDomain, topLevelDomains, distanceFunction, this.topLevelThreshold);

        if (emailParts.topLevelDomain && emailParts.secondLevelDomain) {
            var closestDomain = emailParts.domain;
            var rtrn = false;

            if (closestSecondLevelDomain && closestSecondLevelDomain != emailParts.secondLevelDomain) {
                // The email address may have a mispelled second-level domain; return a suggestion
                closestDomain = closestDomain.replace(emailParts.secondLevelDomain, closestSecondLevelDomain);
                rtrn = true;
            }

            if (closestTopLevelDomain && closestTopLevelDomain != emailParts.topLevelDomain) {
                // The email address may have a mispelled top-level domain; return a suggestion
                closestDomain = closestDomain.replace(emailParts.topLevelDomain, closestTopLevelDomain);
                rtrn = true;
            }

            if (rtrn == true) {
                return {address: emailParts.address, domain: closestDomain, full: emailParts.address + "@" + closestDomain};
            }
        }

        /* The email address exactly matches one of the supplied domains, does not closely
         * match any domain and does not appear to simply have a mispelled top-level domain,
         * or is an invalid email address; do not return a suggestion.
         */
        return false;
    },

    findClosestDomain: function (domain, domains, distanceFunction, threshold) {
        threshold = threshold || this.topLevelThreshold;
        var dist;
        var minDist = 99;
        var closestDomain = null;

        if (!domain || !domains) {
            return false;
        }
        if (!distanceFunction) {
            distanceFunction = this.sift3Distance;
        }

        for (var i = 0; i < domains.length; i++) {
            if (domain === domains[i]) {
                return domain;
            }
            dist = distanceFunction(domain, domains[i]);
            if (dist < minDist) {
                minDist = dist;
                closestDomain = domains[i];
            }
        }

        if (minDist <= threshold && closestDomain !== null) {
            return closestDomain;
        } else {
            return false;
        }
    },

    sift3Distance: function (s1, s2) {
        // sift3: http://siderite.blogspot.com/2007/04/super-fast-and-accurate-string-distance.html
        if (s1 == null || s1.length === 0) {
            if (s2 == null || s2.length === 0) {
                return 0;
            } else {
                return s2.length;
            }
        }

        if (s2 == null || s2.length === 0) {
            return s1.length;
        }

        var c = 0;
        var offset1 = 0;
        var offset2 = 0;
        var lcs = 0;
        var maxOffset = 5;

        while ((c + offset1 < s1.length) && (c + offset2 < s2.length)) {
            if (s1.charAt(c + offset1) == s2.charAt(c + offset2)) {
                lcs++;
            } else {
                offset1 = 0;
                offset2 = 0;
                for (var i = 0; i < maxOffset; i++) {
                    if ((c + i < s1.length) && (s1.charAt(c + i) == s2.charAt(c))) {
                        offset1 = i;
                        break;
                    }
                    if ((c + i < s2.length) && (s1.charAt(c) == s2.charAt(c + i))) {
                        offset2 = i;
                        break;
                    }
                }
            }
            c++;
        }
        return (s1.length + s2.length) / 2 - lcs;
    },

    splitEmail: function (email) {
        var parts = email.trim().split('@');

        if (parts.length < 2) {
            return false;
        }

        for (var i = 0; i < parts.length; i++) {
            if (parts[i] === '') {
                return false;
            }
        }

        var domain = parts.pop();
        var domainParts = domain.split('.');
        var sld = '';
        var tld = '';

        if (domainParts.length == 0) {
            // The address does not have a top-level domain
            return false;
        } else if (domainParts.length == 1) {
            // The address has only a top-level domain (valid under RFC)
            tld = domainParts[0];
        } else {
            // The address has a domain and a top-level domain
            sld = domainParts[0];
            for (var i = 1; i < domainParts.length; i++) {
                tld += domainParts[i] + '.';
            }
            tld = tld.substring(0, tld.length - 1);
        }

        return {
            topLevelDomain: tld,
            secondLevelDomain: sld,
            domain: domain,
            address: parts.join('@')
        }
    },

    // Encode the email address to prevent XSS but leave in valid
    // characters, following this official spec:
    // http://en.wikipedia.org/wiki/Email_address#Syntax
    encodeEmail: function (email) {
        var result = encodeURI(email);
        result = result.replace('%20', ' ').replace('%25', '%').replace('%5E', '^')
            .replace('%60', '`').replace('%7B', '{').replace('%7C', '|')
            .replace('%7D', '}');
        return result;
    }
};

// Export the mailcheck object if we're in a CommonJS env (e.g. Node).
// Modeled off of Underscore.js.
if (typeof module !== 'undefined' && module.exports) {
    module.exports = Mailcheck;
}

// Support AMD style definitions
// Based on jQuery (see http://stackoverflow.com/a/17954882/1322410)
if (typeof define === "function" && define.amd) {
    define("mailcheck", [], function () {
        return Mailcheck;
    });
}

if (typeof window !== 'undefined' && window.jQuery) {
    (function ($) {
        $.fn.mailcheck = function (opts) {
            var self = this;
            if (opts.suggested) {
                var oldSuggested = opts.suggested;
                opts.suggested = function (result) {
                    oldSuggested(self, result);
                };
            }

            if (opts.empty) {
                var oldEmpty = opts.empty;
                opts.empty = function () {
                    oldEmpty.call(null, self);
                };
            }

            opts.email = this.val();
            Mailcheck.run(opts);
        }
    })(jQuery);
}


jQuery(document).ready(function($) {
    $(document).on('keydown', 'input.email-suggest', Util.throttle(function () {

        var that = $(this),
            translations = {
                en: 'Did you mean ',
                de: 'Meinten Sie ',
                fr: 'Voulez-vous dire ',
                es: '¿Quisiste decir ',
                jp: 'もしかして'
            };
        that.next('.suggest').remove();
        that.mailcheck({
            suggested: function (element, suggestion) {
                $('<div class="help-block help-inline suggest">' + translations[Util.getLang()] + '<a href="#">' + suggestion.full + '</a>?</div>').insertAfter(that).click(function (e) {
                    e.preventDefault();
                    that.val(suggestion.full);
                    this.remove();
                });
            }
        });
    }, 1000));
});
